"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

define(['choices'], function (Choices) {
  'use strict';

  return function (config, select) {
    var _defaultOptions;

    var defaultOptions = (_defaultOptions = {
      allowHTML: true,
      placeholder: true,
      searchEnabled: false,
      removeItemButton: false,
      loadingText: 'Laster...',
      noResultsText: 'Ingen resultat funnet',
      noChoicesText: 'Ingen valg tilgjengelig',
      itemSelectText: 'Trykk for å velge',
      position: 'bottom',
      sorter: function sortFilter(a, b) {
        return a.label.localeCompare(b.label);
      },
      classNames: {
        containerInner: 'select__field',
        list: 'select__field-list',
        input: 'select__field-input',
        item: 'select__field-item',
        listItems: 'select__field-list--multiple',
        listSingle: 'select__field-list--single',
        button: 'select__field-button'
      }
    }, _defineProperty(_defaultOptions, "itemSelectText", ''), _defineProperty(_defaultOptions, "callbackOnInit", null), _defaultOptions);

    if (config.type === 'number') {
      defaultOptions.sorter = function (a, b) {
        return a - b;
      };
    }

    if (config.type == 'multiple') {
      defaultOptions.removeItemButton = true;
      defaultOptions.searchEnabled = true;
      defaultOptions.classNames.containerInner = 'select__field-multiple';
    }

    if (config.type == 'event') { }

    if (config.labelledby) {
      defaultOptions.callbackOnInit = addAriaLabelledby;
      defaultOptions.classNames.containerOuter = 'choices labelledby-' + config.labelledby;
    }

    function addAriaLabelledby() {
      jQuery(function ($) {
        $('.choices.labelledby-' + config.labelledby).each(function () {
          $(this).attr('aria-labelledby', config.labelledby);
        });
      });
    }

    ;
    config.options = Object.assign(defaultOptions, config.options);
    new Choices(select, config.options);
  };
});
//# sourceMappingURL=select.babel.js.map
